import React from 'react';
import SEO from '../components/seo';
// import ProjectSliderMonto from '../components/projects/projectSliderMonto';
// import ProjectSliderLemosta from '../components/projects/projectSliderLemosta';
import ProjectSliderLemochlo from '../components/projects/projectSliderLemochlo';
// import { HashLink } from 'react-router-hash-link';
// import $ from 'jquery';

const ProjectPageLemochlo = () => {
  return (
    <>
      <SEO title="レモクロ | Our Projects" />
      <section className="projectVisual">
        <h1 className="visual--title">
          <span>Our</span> Projects
        </h1>
        <p className="visual--desc">
          全人類の健康をアップデートさせるべく
          <br />
          サイレンサーが展開するプロジェクト。
        </p>
      </section>
      <section className="projectWrap">
        <div className="projectBox" id="p3">
          <h2 className="projectName">レモクロ</h2>
          {/* <p className="projectCopy">
            八重山クロレラと広島産レモンのみを使い、
            葉酸・ビタミン・アミノ酸など植物由来の栄養素がつまった食事に近いサプリメント、レモクロ。
            安心の国産・無添加。いらないものを引き、必要な栄養を摂り入れることで現代人の健康をアップデート。
          </p> */}
          <div className="projectSlider--wrap">
            <ProjectSliderLemochlo />
          </div>
          <h3 className="projectOverview">向き合え！自分と</h3>
          <div className="projectText">
            <p>
              誰かを愛した時、誰かを幸せにしたいと心から思った時、もっとも大切な事がある。
            </p>
            <p>それは"自分自身の健康状態"。</p>
            <p>
              その為に必要なのは膨大なネット情報検索や無責任な書き込みではなく、ただ静かに自分の内側に耳を傾け感じ決断する事のみ。
              現代の食物で補いきれないビタミン、ミネラル、アミノ酸。
              それらを日々慌ただしい生活の中でも気楽に取り込める様コンパクトな錠剤にしました。
            </p>
            <p>
              サイレンサーが掲げる「ゴキゲン」な心身は軽負担・最大効率の無添加サプリ「レモクロ」からはじまる。
            </p>
          </div>
          <ul className="projectLink">
            <li>
              <a
                href="https://lemon-chlorella.com/"
                target="_blank"
                rel="noreferrer"
              >
                Online Shop
              </a>
            </li>
          </ul>
        </div>
      </section>
    </>
  );
};

export default ProjectPageLemochlo;
